import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-16" data-mp="1oi82zh1qje4v">
      <div className="max-w-5xl mx-auto" data-id="element-17" data-mp="22ellmti09lkx">
        <div className="text-center mb-16" data-id="element-18" data-mp="22diuckgrth4h">
          <p className="text-gold-dark font-bold tracking-widest uppercase mb-2" data-id="element-19" data-mp="1ydrxq04kc6s1">Included at no extra cost</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand" data-id="element-20" data-mp="1apiglbiao778">🎁 3 Additional Strategic Bonuses</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-21" data-mp="15r77x43qk2ql">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-cream border border-mist rounded-2xl p-8 relative hover:border-gold transition-colors ${index === 2 ? 'md:col-span-2' : ''}`} data-id="element-22" data-mp="1ji28lt42zdj3" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-brand text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-23" data-mp="2eqo2bcvt26z3">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-sand rounded-full flex items-center justify-center text-gold-dark mb-6" data-id="element-24" data-mp="2ogzgds97dwjp">
                <Gift size={24} aria-hidden="true" data-id="element-25" data-mp="1qtqp1gmitt9s" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-24 text-brand" data-id="element-26" data-mp="1qvlacw1pfnee">{bonus.title}</h3>
              <div className="inline-block bg-ivory border border-gold/40 px-3 py-1 rounded mb-4" data-id="element-27" data-mp="1vu4yn33rtb9x">
                <span className="text-mist-text text-sm" data-id="element-28" data-mp="25qhti4b1xv69">
                  Real value: <span className="line-through" data-id="element-29" data-mp="25rsw40srgwvs">${bonus.value}</span>
                </span>
                <span className="text-gold-dark font-bold ml-2" data-id="element-30" data-mp="3c61x8xw0jld5">→ FREE</span>
              </div>
              <p className="text-forest text-sm font-medium mb-4 italic" data-id="element-31" data-mp="3h43fxhpj1io3">{bonus.subtitle}</p>
              {bonus.paragraphs.map(paragraph => <p key={paragraph} className="text-ink/75 text-sm mb-4 leading-relaxed" data-id="element-32" data-mp="1c4kk0oeevmm2">
                  {paragraph}
                </p>)}
              <p className="text-brand text-sm font-bold" data-id="element-33" data-mp="1q3jyj387ml4i">{bonus.benefit}</p>
            </motion.article>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-cream border-2 border-gold rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-34" data-mp="1m0nhvi28cz37">
          <p className="text-ink/70 mb-2" data-id="element-35" data-mp="176sgsy8bge2k">Total value of the 3 additional bonuses</p>
          <p className="text-2xl text-mist-text line-through mb-4" data-id="element-36" data-mp="12dg3vld01vpn">$34.00</p>
          <p className="text-lg text-brand mb-2" data-id="element-37" data-mp="eoeqdjpb7udi">Your price today</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-38" data-mp="emk7sc1igecl">🎁 FREE</p>
          <p className="text-sm text-forest" data-id="element-39" data-mp="an30dd2ix74s">Only included in this offer.</p>
        </motion.div>
      </div>
    </section>;
}